import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store';
import Login from '../views/Login.vue';
import Logout from '../views/Logout.vue';
import Home from '../views/Home.vue';
import Data from '../views/Data.vue';
import Authentication from '../views/Authentication.vue';
import Dash from '../views/Dash.vue';
import FCM from '../views/FCM.vue';

import Root from '@/views/Root.vue';
import Exports from '@/views/Exports.vue';
import Mtp from '@/modules/mtp/Mtp.vue';

import Questionnaires from '../components/RevData/Questionnaires';
import Subjects from '../components/RevData/Subjects';
import Subtopics from '../components/RevData/Subtopics';
import Tags from '../components/RevData/Tags';
import Explanations from '../components/RevData/Explanations';
import Courses from '../components/RevData/Courses';
import CourseCreate from '../components/RevData/CourseCreate';
import CourseView from '../components/RevData/CourseView';
import CourseUpdate from '../components/RevData/CourseUpdate.vue';
import SubjectView from '../components/RevData/SubjectView';
import SubjectAddUpdate from '../components/RevData/SubjectAddUpdate';

import { reviewerRoutes } from '../modules/reviewer/router/reviewerRoutes';
import { schedulerRoutes } from '../modules/scheduler/router/schedulerRoutes';
import { v3UsersRoutes } from '../v3/modules/users/router/v3UsersRoutes';

import { softBlockRoutes } from '../modules/soft_block/router/softBlockRoutes';
import { scorecardRoutes } from '../modules/scorecard/router/scorecardRoutes';
import { rewardRoutes } from '../modules/reward/router/rewardRoutes';
import { plusSurveyRoutes } from '../modules/plus_survey/router/plusSurveyRoutes';

// for just dummy data when running the emulator
import DummyData from '../views/DummyData.vue';

// Added for testing on October 18, 2023
import Nest from '../views/Nest.vue';
import Coupons from '../views/Coupons.vue';
import ValidateCoupon from '../views/ValidateCoupon.vue';

/**
 * V2 Components
 */

import V2ParentView from '@/v2/views/V2ParentView.vue';
import V2Dash from '@/v2/modules/dash/DashView.vue';
import V2DashNew from '@/v2/modules/dash/DashViewNew.vue';
import V2Users from '@/v2/modules/users/UsersView.vue';
import V2User from '@/v2/modules/users/UserView.vue';
import V2UserNew from '@/v2/modules/users/UserViewNew.vue';
import V2PurchasePage from '@/v2/modules/users/PurchasePage.vue';
import V2Materials from '@/v2/modules/materials/MaterialsView.vue';
import V2Profile from '@/v2/modules/profile/ProfileView.vue';
import V2League from '@/v2/modules/league/LeagueView.vue';

// Added for testing on December 1, 2023
import Dome from '../views/Dome.vue';

// Added for testing on Jan 31, 2024
import Finance from '../views/Finance.vue';

// Added for testing on Jul 6, 2024
import { monitorRoutes } from '../modules/monitor/router/monitorRoutes';
import { transactionsRoutes } from '../v4/transactions/transactionsRoutes';
import { exploreRoutes } from '../v4/explore/exploreRoutes';
import { couponsRoutesV2 } from '../v4/coupons/couponsRoutes';
import { scorecardRoutesV2 } from '../v4/scorecard/scorecardRoutes';
import { endorsersRoutes } from '../v4/endorsers/endorsersRoutes';
import { rewardRoutesV2 } from '../v4/reward/rewardRoutes';


const routes = [
    ...monitorRoutes,
    ...reviewerRoutes,
    ...schedulerRoutes,
    ...v3UsersRoutes,
    ...softBlockRoutes,
    ...scorecardRoutes,
    ...rewardRoutes,
    ...plusSurveyRoutes,
    ...transactionsRoutes,
    ...exploreRoutes,
    ...couponsRoutesV2,
    ...scorecardRoutesV2,
    ...endorsersRoutes,
    ...rewardRoutesV2,
    {
        path: '/:action/dummy-data',
        component: DummyData
    },
    {
        path: '/login',
        name: 'Login',
        component: Login
    },
    {
        path: '/logout',
        name: 'Logout',
        component: Logout,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
            requiresAuth: true
        }
    },
    // {
    //     path: '/dash',
    //     name: 'Dash',
    //     component: Dash,
    //     meta: {
    //         requiresAuth: true,
    //         accessId: 'dash',
    //     }
    // },
    {
        path: '/dash',
        name: 'Dash',
        component: V2DashNew,
        meta: {
            requiresAuth: true,
            accessId: 'dash',
        }
    },
    {
        path: '/nest',
        name: 'Nest',
        component: Nest,
        meta: {
            requiresAuth: true,
            accessId: 'nest',
        }
    },
    /**
     * An experiment page by John. Please ignore
     */
    {
        path: '/dome',
        name: 'Dome',
        component: Dome,
        meta: {
            requiresAuth: true,
            accessId: 'dome',
        }
    },
    /**
     * An experiment page by John for Finance. Please ignore
     */
    {
        path: '/finance',
        name: 'Finance',
        component: Finance,
        meta: {
            requiresAuth: true,
            accessId: 'finance',
        }
    },
    // Temporary hidden page for tracking the private-release invitation banner/modal. Not in nav.
    {
        path: '/private-release-invitations',
        name: 'PrivateReleaseInvitations',
        component: () =>
            import ('../views/PrivateReleaseInvitations.vue'),
        meta: {
            requiresAuth: true,
        }
    },
    // Hidden ENG-17 tool: find/delete duplicate explanations by questionId. Not in nav.
    {
        path: '/tools/explanations-dedupe',
        name: 'ExplanationsDedupe',
        component: () =>
            import ('../views/ExplanationsDedupe.vue'),
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/coupons-v2',
        name: 'CouponsV2',
        component: Coupons,
        meta: {
            requiresAuth: true,
            accessId: 'coupons',
        }
    },
    {
        path: '/coupon',
        name: 'Coupon',
        component: ValidateCoupon,
        meta: {
            requiresAuth: true,
            accessId: 'coupon',
        }
    },
    {
        path: '/exports',
        name: 'Exports',
        component: Exports,
        meta: {
            requiresAuth: true,
            accessId: 'exports',
        }
    },
    {
        path: '/root',
        name: 'Root',
        component: Root,
        meta: {
            requiresAuth: true,
            accessId: 'root',
        }
    },
    {
        path: '/mtp',
        name: 'MTP',
        component: Mtp,
        meta: {
            requiresAuth: true,
            accessId: 'mtp',
        }
    },
    {
        path: '/users',
        name: 'Users',
        component: V2UserNew,
        meta: {
            requiresAuth: true
        }
    },

    /**
     * V2 Routes
     */
    {
        path: '/v2',
        component: V2ParentView,
        meta: { 
            requiresAuth: true,
            accessId: 'v2_dash',
        },
        redirect: { path: '/v2/dash' },
        children: [{
                path: 'dash',
                component: V2Dash,
                meta: { requiresAuth: true, childAccessId: 'v2_landing' }
            },
            {
                path: 'dash-v2',
                component: V2DashNew,
                meta: { requiresAuth: true, childAccessId: 'v2_landing' }
            },
            {
                path: 'users',
                component: V2Users,
                meta: { requiresAuth: true, childAccessId: 'v2_users' }
            },
            {
                path: 'users-v2',
                name: 'users-v2',
                component: V2UserNew,
                meta: { requiresAuth: true, childAccessId: 'v2_users' }
            },
            {
                path: 'user/:id',
                component: V2User,
                meta: { requiresAuth: true, childAccessId: 'v2_users' }
            },
            {
                path: 'purchase',
                component: V2PurchasePage,
                meta: { requiresAuth: true, childAccessId: 'v2_users' }
            },
            {
                path: 'materials',
                component: V2Materials,
                meta: { requiresAuth: true, childAccessId: 'v2_materials' }
            },
            {
                path: 'league',
                component: V2League,
                meta: { requiresAuth: true, childAccessId: 'v2_league' }
            },
            {
                path: 'profile',
                component: V2Profile,
                meta: { requiresAuth: true }
            },
        ],
    },

    // reviewer data routes
    {
        path: '/data',
        component: Data,
        children: [{
                path: 'questionnaires',
                component: Questionnaires
            },
            {
                path: 'courses',
                component: Courses
            },
            {
                path: 'courses/create',
                component: CourseCreate
            },
            {
                path: 'courses/:course',
                component: CourseView,
                props: true,
            },
            {
                path: 'courses/:course/update',
                component: CourseUpdate,
                props: true,
            },
            {
                path: 'subjects',
                component: Subjects
            },
            {
                path: 'subjects/view/:subject',
                component: SubjectView,
                props: true,
            },
            {
                path: 'subjects/:actionType/:subject?',
                component: SubjectAddUpdate,
                props: true,
            },
            {
                path: 'subtopics',
                component: Subtopics
            },
            {
                path: 'tags',
                component: Tags
            },
            {
                path: 'explanations',
                component: Explanations
            },
        ],
        meta: {
            requiresAuth: true,
            accessId: 'data',
        }
    },

    // authentication routes
    {
        path: '/authentication',
        name: 'Authentication',
        component: Authentication,
        meta: {
            requiresAuth: true,
            accessId: 'authentication',
        }
    },


    {
        path: '/fcm',
        name: 'FCM',
        component: FCM,
        mete: {
            requiresAuth: true,
            accessId: 'fcm',
        }
    },

    {
        path: '/:pathMatch(.*)*',
        name: '404',
        component: () =>
            import ( /* webpackChunkName: "404" */ '../views/404.vue')
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

// router.beforeResolve
router.beforeResolve(async(to, from, next) => {

    // required auth route...
    if (to.matched.some(record => record.meta.requiresAuth) && !store.state.user.credentials) {
        next({ name: 'Login' });
        return;
    }

    // login route...
    // check if user already login, reroute to home page
    if (to.name === 'Login' && store.state.user.credentials) {
        next({ name: 'Home' });
        return;
    }

    // log out route...
    // if (to.name === 'Logout') {
    //     console.log('logging out...');
    //     await logOut();
    //     // console.log('logged out, setting user to null...')
    //     // await store.dispatch('setUser', null);
    //     console.log('rerouting to login...')
    //     next({ name: 'Login' });
    //     return;
    // }
    next();
})


router.beforeEach(async (to, from, next) => routeGuard(to, from, next));

function routeGuard(to, from, next) {
  console.log('from:', from);
  console.log(`🚦 %cAccessing route: ${to.path}`, 'color:#b4d455');

  const accessId = to.meta.accessId;

  if (accessId) {
    const adminAccess = store.state.user?.otherInfo?.adminAccess;

    if (!adminAccess) {
      console.warn('🚫 No admin access info. Redirecting to Home.');
      return next({ name: 'Home' });
    }

    if (!adminAccess.hasFullAccess) {

        if (!adminAccess[accessId]) {
            console.warn(`🚫 No access to "${accessId}". Redirecting to Home.`);
            return next({ name: 'Home' });
        }

        // check if the user has access to the v2 dashboard
        if (accessId === 'v2_dash') {
            // get the child access id
            const childAccessId = to.meta.childAccessId;
            // check if the user has access to the child access id
            if (childAccessId) {
                if (!adminAccess[childAccessId]) {
                    console.warn(`🚫 No access to "${childAccessId}". Redirecting to V2 Profile.`);

                    // check if user has access to v2_users, if yes, redirect to v2_users, if no, redirect to v2/users
                    if (adminAccess['v2_users']) {
                        return next('/v2/users');
                    } else {
                        return next('/v2/profile');
                    }

                }
            }
        }
        
      
    }
  }

  console.log(`✅ %cEnd of route guard. Proceeding.`, 'color:#b4d455');
  next();
}

export default router